import { actionTypesOfReasonForVisit } from 'reducer/actionType';
import { PodiatryConditionalOptionsType } from 'types/types';
import { painWorstOptions } from 'lib/commonOptions';

export const beforeIntoTheOfficeOptions: PodiatryConditionalOptionsType = {
  title: 'Have you been into the office about this problem before?',
  subTitle: 'Choose one',
  options: ['Yes', 'No'],
};

export const reasonForVisitOptions: PodiatryConditionalOptionsType = {
  title: 'Reason for visit',
  subTitle: 'Choose one',
  options: [
    'Foot',
    'Heel',
    'Ankle',
    'Calf',
    'Knee',
    'Thigh / hamstring',
    'Hip',
    'Back',
    'Hand / wrist',
    'Elbow',
    'Shoulder',
    'Neck',
  ],
};

export const reasonForVisitContOptions: PodiatryConditionalOptionsType = {
  title: 'Reason for visit',
  subTitle: 'Choose all that apply',
  options: [
    'Foot pain',
    'Heel pain',
    'Ankle pain',
    'Skin condition',
    'Toenail condition',
    'Toe alignment / foot deformity',
    'Diabetic foot care',
    "Children's condition",
    'Injury or trauma',
    'Other',
  ],
};

export const whichFootOptions = {
  title: 'Which foot?',
  subTitle: 'Choose one',
  options: ['Left', 'Right', 'Both'],
};

export const haveYouSeenOtherProviderOptions = {
  title: 'Have you seen any other providers for this?',
  subTitle: 'Choose one',
  options: ['Yes', 'No'],
};

export const conditionalOptions: PodiatryConditionalOptionsType[] = [
  {
    name: actionTypesOfReasonForVisit.CONSISTENTLY_OR_OFF_PROBLEM,
    title: 'Consistently, or on and off?',
    subTitle: 'Choose one',
    options: ['Consistently', 'On and off'],
  },
  {
    name: actionTypesOfReasonForVisit.HOW_DID_IT_START,
    title: 'How did it start?',
    subTitle: 'Choose one',
    options: [
      'Accident at work',
      'Slip and fall',
      'Car accident',
      'Repetitive stress / exercise',
      'Diabetes',
      'Chronic condition',
      'Unknown',
      'Other',
    ],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_TYPE_OF_PAIN,
    title: 'What type of pain?',
    subTitle: 'Choose all that apply',
    options: [
      'Throbbing',
      'Radiating',
      'Stabbing',
      'Pins & needles',
      'Aching',
      'Stinging',
      'Other',
      'None',
    ],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_ARE_YOUR_SYMPTOMS,
    title: 'What are your OTHER symptoms?',
    subTitle: 'Choose all that apply',
    options: [
      'Redness',
      'Swelling',
      'Discoloration',
      'Flaking',
      'Drainage',
      'Open wound',
      'Nail thickening',
      'Other',
    ],
  },
  {
    name: actionTypesOfReasonForVisit.PAIN_WORST,
    title: 'When is the pain worst?',
    subTitle: 'Choose all that apply',
    options: painWorstOptions,
  },
  {
    name: actionTypesOfReasonForVisit.WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER,
    title:
      'Which of the following can you no longer do because of your condition?',
    subTitle: 'Choose all that apply',
    options: [
      'Groom yourself',
      'Get in a car',
      'Go to work',
      'Walk more than 200 feet without stopping',
      'Chores around the house',
      'Work normally',
      'Exercise normally',
      "Don't work at all",
      'No major life changes',
      'Not applicable',
    ],
  },
  {
    name: actionTypesOfReasonForVisit.TREATMENTS_TRIED_HOME,
    title: 'What treatments have you tried at home?',
    subTitle: 'Choose all that apply',
    options: [
      'Soaking',
      'Over the counter pain reliever (e.g. Tylenol, Motrin)',
      'Topical creams, gels, or patches',
      'Ice',
      'Different shoes',
      'Shoe inserts',
      'Heating pads',
      'Rest',
      'Elevation',
      'Other',
    ],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_TREATMENTS_DID_PROVIDER,
    title: 'What treatments were recommended by your previous provider?',
    subTitle: 'Choose all that apply',
    options: [
      'Orthotic',
      'Injection',
      '(Oral) prescription medication',
      '(Topical) prescription medication',
      'Physical therapy',
      'X-Ray',
      'Surgery',
      'MRI',
      'CAT scan',
      'Home exercises',
    ],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_TREATMENTS_WERE_HELPFUL,
    title: 'Which treatments were helpful?',
    subTitle: 'Choose all that apply',
    options: [
      'Injection',
      'Physical therapy',
      'Over the counter pain reliever (e.g. Tylenol, Motrin)',
      'Different shoes',
      'Rest',
    ],
  },
];
